import { CommonModule } from '@angular/common';
import { HttpErrorResponse } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { ConfirmationService, MessageService } from 'primeng/api';
import { ButtonModule } from 'primeng/button';
import { CardModule } from 'primeng/card';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { InputTextModule } from 'primeng/inputtext';
import { TableModule } from 'primeng/table';
import { TabsModule } from 'primeng/tabs';
import { ToastModule } from 'primeng/toast';
import { CurrentUser } from '../../models/current-user';
import { ApiService } from '../../services/api.service';
import { SanitizerService } from '../../services/sanitizer.service';
import { Parameters } from '../../utilities/parameters';
import { DividerModule } from 'primeng/divider';
import { PasswordModule } from 'primeng/password';
import { UserOrganization } from '../../models/organization';
import { InputNumberModule } from 'primeng/inputnumber';

@Component({
  selector: 'app-current-user',
  imports: [
    CommonModule,
    FormsModule,
    ToastModule,
    ConfirmDialogModule,
    CardModule,
    TabsModule,
    InputTextModule,
    TableModule,
    ButtonModule,
    DividerModule,
    PasswordModule,
    InputNumberModule
  ],
  templateUrl: './current-user.component.html',
  styles: ``,
  providers: [ConfirmationService, MessageService]
})
export class CurrentUserComponent implements OnInit{
  user: CurrentUser;
  ruoli: string[];

  oldValue: string = '';
  newValue: string = '';
  chkValue: string = '';

  strongRegex: string = "^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.{8,})";
  strongCheckRegExp: RegExp = new RegExp(this.strongRegex);

  expandedRows = {};
  tabsId: number = 0;

  constructor(private confirmationService: ConfirmationService,
    private messageService: MessageService,
    private apiService: ApiService, private sanitizer: SanitizerService) {
    this.user = { ...Parameters.loggedUser };
    this.ruoli = Parameters.decodificaRuoli(this.user.role);
  }

  ngOnInit(): void {
    this.tabsId = 0;
  }

  showSuccess(message: string) {
    this.messageService.add({ key: 'tc', severity: 'success', summary: 'Success', detail: message });
  }

  showError(err: HttpErrorResponse) {
    let message: string = err.error !== null ? (typeof err.error === 'string' ? err.error : err.error.message) : err.message
    this.showErrorMessage(message);
  }

  showErrorMessage(message: string) {
    this.messageService.add({ key: 'tc', severity: 'error', summary: 'Error', detail: message });
  }

  onCancel() {
    this.user = { ...Parameters.loggedUser };
  }

  onChange() {
    if (this.oldValue.trim().length == 0) {
      this.showErrorMessage("Inserisci la Vecchia Password!");
      return;
    }

    if (!this.strongCheckRegExp.test(this.newValue)) {
      this.showErrorMessage("La Nuova Password non rispetta i requisiti!");
      this.newValue = '';
      this.chkValue = '';

      return;
    }

    if (this.newValue != this.chkValue) {
      this.showErrorMessage("La Nuova Password non corrisponde!");
      this.newValue = '';
      this.chkValue = '';

      return;
    }

    this.apiService.changePassword(this.oldValue, this.newValue).subscribe({
      next: (status: boolean) => {
        if (status)
          this.showSuccess("La password è stata aggiornata!");
        else
          this.showErrorMessage("Si è verificato un errore!");
      },
      error: (err: HttpErrorResponse) => {
        this.showError(err);
      }
    });
  }

  onRemoveOrganization(event: Event, org: UserOrganization): void {
    this.confirmationService.confirm({
      target: event.target as EventTarget,
      message: `Vuoi rimuovere l\'associazione con ${org.name}?`,
      header: 'Conferma',
      closable: false,
      closeOnEscape: false,
      icon: 'far fa-trash-can',
      rejectButtonProps: {
        label: 'Annulla',
        severity: 'secondary',
        outlined: true,
      },
      acceptButtonProps: {
        label: 'Rimuovi',
      },
      accept: () => {
        this.user.organizations = this.user.organizations.filter(o => o.organizationId != org.organizationId);
      },
      reject: () => {
        this.showErrorMessage("La procedura è stata annullata dall'utente!")
      },
    });
  }

  onSave() {
    this.sanitizeUser();

    this.apiService.updateCurrentUser(this.user).subscribe({
      next: () => {
        Parameters.loggedUser = { ...this.user };
        this.showSuccess("L'utente è stato aggiornato!");
      },
      error: (err: HttpErrorResponse) => {
        this.showError(err);
      }
    });
  }

  private sanitizeUser() {
    this.user.name = this.sanitizer.sanitizeData(this.user.name);
    this.user.familyName = this.sanitizer.sanitizeData(this.user.familyName);
    this.user.userName = this.sanitizer.sanitizeData(this.user.userName);
    this.user.email = this.sanitizer.sanitizeData(this.user.email);
  }
}
